module.exports = __webpack_public_path__ + "static/img/dnex.c2cee6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/dnex.jpg
// module id = wxX7
// module chunks = 8